import React from "react";
import "./index.css";
import "antd/dist/antd.min.css";

import {PersistGate} from "redux-persist/integration/react"
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { render } from "react-dom";

import MyAccountRoutes from "./v2/routes/MyAccountRoutes";
import AuthRoutes from "~components/routes/AuthRoutes";
import LandingPage from "~v2/pages/LandingPage/LandingPage";
import TreRoutes from "~v2/routes/TreRoutes";
import AdminRoutes from "~v2/routes/AdminRoutes";
import ProtectedRoutes from "~v2/routes/ProtectedRoutes";
import AccountRoutes from "./v2/routes/AccountRoutes";
import Settings from "./v2/pages/SettingsPage/Settings";
import AppContainer from "./v2/components/AppContainer/AppContainer";
import { Provider } from "react-redux"
import {persistor, rootStore} from "./store/root.store";
const rootElement = document.getElementById("root");

render(
  // Develop and Deployed By:
  // Innoendo IT Solutions
  <Provider store={rootStore}>
    <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="auth/*" element={<AuthRoutes />} />

        <Route
          path="v2/Administrator/*"
          element={
            <ProtectedRoutes
              isTokenBasePermissions
              tokenPermissions={{ role: "Administrator", property: "loginAs" }}
              component={<AdminRoutes />}
            />
          }
        />

        <Route
          path="v2/TRE/*"
          element={
            <ProtectedRoutes
              isTokenBasePermissions
              tokenPermissions={{ role: "TRE", property: "loginAs" }}
              component={<TreRoutes />}
            />
          }
        />

        <Route
          path="v2/settings"
          element={<ProtectedRoutes component={<Settings />} />}
        />
        <Route
          path="v2/accounts/*"
          element={<ProtectedRoutes component={<AccountRoutes />} />}
        />

        <Route
          path="v2/my-account/*"
          element={
            <ProtectedRoutes
              component={
                <AppContainer>
                  <MyAccountRoutes />
                </AppContainer>
              }
            />
          }
        />
      </Routes>
    </BrowserRouter>
    </PersistGate>
  </Provider>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
